import {RootState} from "../store";

function selectLastRequestedSessionKey(state: RootState): string {
	return state.chapterSessions.lastRequested.key;
}

export default selectLastRequestedSessionKey;
